// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3f3xj","header":"MessagesList_header__Rq8Dv","chat":"MessagesList_chat__1sOQ8"};